import { en } from './en';
import { es } from './es';
import { de } from './de';
import { sl } from './sl';
import { sr } from './sr';

export const translations = {
  en,
  es,
  de,
  sl,
  sr
};

export const getTranslation = (languageCode, key) => {
  const translation = translations[languageCode] || translations.en;
  
  // Navigate through nested object using dot notation (e.g., 'nav.home')
  const keys = key.split('.');
  let result = translation;
  
  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k];
    } else {
      // Fallback to English if key not found
      let fallback = translations.en;
      for (const fallbackKey of keys) {
        if (fallback && typeof fallback === 'object' && fallbackKey in fallback) {
          fallback = fallback[fallbackKey];
        } else {
          return key; // Return key if not found in fallback either
        }
      }
      return fallback;
    }
  }
  
  return result;
};